import React, { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import ConfirmPopup from '../../../Popups/ConfirmPopup'
import RadioField from '../../../FormLegacy/FormFieldsV2/RadioField'

export const useConfirmationModal = () => {
  const { t } = useTranslation(['eventManagement'])
  const [isOpen, setIsOpen] = useState(false)
  const [resolvePromise, setResolvePromise] = useState(null)
  const [selected, setSelected] = useState('false')
  const isMountedRef = useRef(true)

  const askConfirmation = () => {
    setIsOpen(true)
    return new Promise((resolve) => {
      if (isMountedRef.current) {
        setResolvePromise(() => resolve)
      }
    })
  }

  const handleConfirm = () => {
    setIsOpen(false)
    if (isMountedRef.current && resolvePromise) {
      resolvePromise(selected)
    }
  }

  const handleCancel = () => {
    setIsOpen(false)
    if (isMountedRef.current && resolvePromise) {
      resolvePromise(null)
    }
  }

  useEffect(() => {
    isMountedRef.current = true
    return () => {
      isMountedRef.current = false // cleanup on unmount
    }
  }, [])

  const ConfirmationModal = () =>
    isOpen ? (
      <ConfirmPopup
        isOpen={isOpen}
        cancelCallback={handleCancel}
        confirmCallback={handleConfirm}
        cancelText={t('eventManagement:common.cancel')}
        confirmText={t('eventManagement:common.confirm')}
        title={t('eventManagement:common.caution')}
        body={
          <React.Fragment>
            <div>{t('eventManagement:common.updateRecurringEventPrompt')}</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
              <RadioField
                type="radio"
                name="eventsToUpdate"
                value="false"
                label={t('eventManagement:common.updateOnlyThisEvent')}
                onChange={(e) => setSelected(e.target.value)}
                checked={selected === 'false'}
              />
              <RadioField
                type="radio"
                name="eventsToUpdate"
                value="future"
                label={t('eventManagement:common.updateAllFutureEvents')}
                onChange={(e) => setSelected(e.target.value)}
                checked={selected === 'future'}
              />
              <RadioField
                type="radio"
                name="eventsToUpdate"
                value="true"
                label={t('eventManagement:common.updateAllEvents')}
                onChange={(e) => setSelected(e.target.value)}
                checked={selected === 'true'}
              />
            </div>
          </React.Fragment>
        }
      />
    ) : null

  return { askConfirmation, ConfirmationModal }
}
